import { styled } from 'styled-components';

import { FilestackImage } from '#/components/FilestackImage/FilestackImage';
import { ConditionalStyledLinkWithRef } from '#/components/Link/ConditionalStyledLinkWithRef';
import type {
  CmsApiSplitBlockAppearance,
  CmsApiSplitBlockImage,
} from '#/modules/cms/api/types/blocks/CmsApiSplitContentBlock';

import {
  CmsSplitContentImageContent_Box_1,
  CmsSplitContentImageContent_Box_2,
} from './CmsSplitContentImageContent.styled';

export const ImageContainer = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

type Props = {
  appearance: CmsApiSplitBlockAppearance;
  blockId: string;
  section: CmsApiSplitBlockImage;
  showBackgroundImage: boolean;
  hideImage: boolean;
  imageTextBlock: boolean;
  imageQuoteBlock: boolean;
  index: number;
  preview: boolean;
};

export function CmsSplitContentImageContent({
  appearance,
  blockId,
  hideImage,
  imageTextBlock,
  imageQuoteBlock,
  index,
  preview,
  section,
  showBackgroundImage,
}: Props) {
  const overlapping = appearance === 'OVERLAPPING';
  const fullWidth = appearance === 'FULL_WIDTH';
  const fixedWidth = section.data.size === 'FIXED_WIDTH';
  const centeredFullWidth = fullWidth && !preview;

  if (showBackgroundImage || hideImage) return null;

  return (
    <CmsSplitContentImageContent_Box_1
      data-qa-id={`split-content-section-${index}`}
      data-not-full-width={!fullWidth ? true : undefined}
      data-not-image-text-block={!imageTextBlock ? true : undefined}
      key={blockId}
    >
      <CmsSplitContentImageContent_Box_2
        data-fixed-width={fixedWidth ? true : undefined}
        data-overlapping={overlapping ? true : undefined}
        data-full-width={fullWidth ? true : undefined}
        data-centered={centeredFullWidth ? true : undefined}
        data-negative-margin-left={
          overlapping && index === 1 ? true : undefined
        }
      >
        <ConditionalStyledLinkWithRef
          link={section.data.url}
          qaId="split-content-section-image-url"
        >
          <ImageContainer>
            <FilestackImage
              qaId="split-content-section-image"
              data={section.data.image}
              alt={section.data.image.altText ?? section.data.image.filename}
              width={(() => {
                if (fullWidth) return 1440;
                if (overlapping) return 696;
                return 552;
              })()}
              expandSize={!fixedWidth}
              objectFit={!fixedWidth ? 'cover' : 'contain'}
              style={{
                height: fixedWidth ? 'auto' : '100%',
                borderRadius:
                  (imageTextBlock || imageQuoteBlock) && !fullWidth
                    ? '10px'
                    : undefined,
              }}
            />
          </ImageContainer>
        </ConditionalStyledLinkWithRef>
      </CmsSplitContentImageContent_Box_2>
    </CmsSplitContentImageContent_Box_1>
  );
}
